import React from 'react';
import { Typography } from 'antd';
import PropTypes from 'prop-types';

const { Paragraph } = Typography;

const Derived = ({ value, format, options }) => {
  const formattedValue = React.useMemo(() => {
    if (format) return format(value);
    return value;
  }, [value, format]);

  return <Paragraph {...options}>{formattedValue}</Paragraph>;
};

Derived.propTypes = {
  value: PropTypes.string,
  format: PropTypes.func,
  options: PropTypes.shape({
    ellipsis: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
    editable: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
    copyable: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
    code: PropTypes.bool,
    strong: PropTypes.bool,
    italic: PropTypes.bool,
    underline: PropTypes.bool,
    mark: PropTypes.bool,
    delete: PropTypes.bool,
    type: PropTypes.oneOf(['secondary', 'success', 'warning', 'danger']),
  }),
};

Derived.defaultProps = {
  value: undefined,
  format: undefined,
  options: {
    ellipsis: false,
    editable: false,
    copyable: false,
    code: false,
  },
};

export default Derived;
